import { baseApi, baseAuthApi } from "../../service/baseApi";
import rtkQueryErrorLogger from "./rtkQueryErrorLogger";

export const RTKMiddleware = [baseApi.middleware, baseAuthApi.middleware, rtkQueryErrorLogger];
